import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { appRegistrySetup } from './setup';

/**
 * Update consents for the user's org's Enterprise Entitlement
 * @param {object} params
 * @param {object} signal
 */
export default async (params, signal = null) => {
  const requiredParams = ['accessToken', 'orgId', 'action', 'appId', 'appVersionId'];
  const paramsRules = {
    accessToken: { allowedTypes: ['string'] },
    orgId: { allowedTypes: ['string'] },
    appId: { allowedTypes: ['string'] },
    appVersionId: { allowedTypes: ['string'] },
    action: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(`${appRegistrySetup.endpoint}/entitlement-api/v2/enterprise/consent`, {
    signal,

    method: 'PATCH',
    headers: {
      'x-api-key': appRegistrySetup.apiKey,
      Authorization: params.accessToken,
      'x-org-id': params.orgId,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      action: params.action,
      appId: params.appId,
      appVersionId: params.appVersionId,
      notes: params.notes,
    }),
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content ?? [];
  }
};
